// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var TypeUtils = require("../../../shared/src/types/TypeUtils.bs.js");

var Status = {};

function fromEnum(param) {
  return param;
}

function toEnum(param) {
  switch (param) {
    case 0 :
        return /* Location */0;
    case 1 :
        return /* DateTime */1;
    case 2 :
        return /* BasicInfo */2;
    case 3 :
        return /* Details */3;
    case 4 :
        return /* Confirmation */4;
    default:
      return ;
  }
}

var include = TypeUtils.TypeClasses.WithGenerateable({
      startingIndex: 0,
      fromEnum: fromEnum,
      toEnum: toEnum
    });

var compare = include.compare;

function toIcon(param) {
  switch (param) {
    case /* Location */0 :
        return {
                TAG: /* Shift */6,
                _0: /* Location */13
              };
    case /* DateTime */1 :
        return {
                TAG: /* Shift */6,
                _0: /* CalendarChecked */2
              };
    case /* BasicInfo */2 :
        return {
                TAG: /* Shift */6,
                _0: /* Users */23
              };
    case /* Details */3 :
        return {
                TAG: /* Shift */6,
                _0: /* Shirt */19
              };
    case /* Confirmation */4 :
        return {
                TAG: /* Status */8,
                _0: /* CircleChecked */4
              };
    
  }
}

function getStepStatus(currentlyActiveStep, step) {
  var param = Curry._2(compare, step, currentlyActiveStep);
  if (param === "greater_than") {
    return /* Incomplete */0;
  } else if (param === "less_than") {
    return /* Completed */2;
  } else {
    return /* Active */1;
  }
}

function toString(param) {
  switch (param) {
    case /* Location */0 :
        return "location";
    case /* DateTime */1 :
        return "date_time";
    case /* BasicInfo */2 :
        return "basic_info";
    case /* Details */3 :
        return "details";
    case /* Confirmation */4 :
        return "confirmation";
    
  }
}

function fromString(param) {
  switch (param) {
    case "basic_info" :
        return /* BasicInfo */2;
    case "confirmation" :
        return /* Confirmation */4;
    case "date_time" :
        return /* DateTime */1;
    case "details" :
        return /* Details */3;
    case "location" :
        return /* Location */0;
    default:
      return ;
  }
}

var fromEnum$1 = include.fromEnum;

var toEnum$1 = include.toEnum;

var eq = include.eq;

var Ord = include.Ord;

var compareWithConversion = include.compareWithConversion;

var compareReversed = include.compareReversed;

var OrdReversed = include.OrdReversed;

var compareAsInt = include.compareAsInt;

var min = include.min;

var max = include.max;

var lessThan = include.lessThan;

var lt = include.lt;

var lessThanOrEq = include.lessThanOrEq;

var lte = include.lte;

var greaterThan = include.greaterThan;

var gt = include.gt;

var greaterThanOrEq = include.greaterThanOrEq;

var gte = include.gte;

var clamp = include.clamp;

var between = include.between;

var OrdRingExtensions = include.OrdRingExtensions;

var OrdNamed = include.OrdNamed;

var OrdBy = include.OrdBy;

var $$Set = include.$$Set;

var SetWithNone = include.SetWithNone;

var $$Map = include.$$Map;

var list = include.list;

var array = include.array;

var set = include.set;

var setWithNone = include.setWithNone;

var cardinality = include.cardinality;

var top = include.top;

var bottom = include.bottom;

var succ = include.succ;

var pred = include.pred;

exports.Status = Status;
exports.fromEnum = fromEnum$1;
exports.toEnum = toEnum$1;
exports.eq = eq;
exports.compare = compare;
exports.Ord = Ord;
exports.compareWithConversion = compareWithConversion;
exports.compareReversed = compareReversed;
exports.OrdReversed = OrdReversed;
exports.compareAsInt = compareAsInt;
exports.min = min;
exports.max = max;
exports.lessThan = lessThan;
exports.lt = lt;
exports.lessThanOrEq = lessThanOrEq;
exports.lte = lte;
exports.greaterThan = greaterThan;
exports.gt = gt;
exports.greaterThanOrEq = greaterThanOrEq;
exports.gte = gte;
exports.clamp = clamp;
exports.between = between;
exports.OrdRingExtensions = OrdRingExtensions;
exports.OrdNamed = OrdNamed;
exports.OrdBy = OrdBy;
exports.$$Set = $$Set;
exports.SetWithNone = SetWithNone;
exports.$$Map = $$Map;
exports.list = list;
exports.array = array;
exports.set = set;
exports.setWithNone = setWithNone;
exports.cardinality = cardinality;
exports.top = top;
exports.bottom = bottom;
exports.succ = succ;
exports.pred = pred;
exports.toIcon = toIcon;
exports.getStepStatus = getStepStatus;
exports.toString = toString;
exports.fromString = fromString;
/* include Not a pure module */
